// src/views/EstadosFlujos/Informacion/EditarInformacion.jsx
import React, { useState, useEffect } from "react";
import { appFetchJson, apiFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";
import ComboMultiSelectClientes from "../../../components/Modales/ComboMultiSelectClientes";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";

import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import ModalBase from "../../../components/Modales/ModalBase";

export default function EditarInformacion({
  onClose = () => {},
  onUpdated = () => {},
  data = {},
}) {
  const [fecha, setFecha] = useState(data.fecha || "");
  const [descripcion, setDescripcion] = useState(data.descripcion || "");
  const [selectedClientes, setSelectedClientes] = useState(
    data.clienteIds || [],
  );
  const [selectedEess, setSelectedEess] = useState(data.eess || null);
  const [tarjeta, setTarjeta] = useState(data.tarjeta || "");
  const [saving, setSaving] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [clientesLoading, setClientesLoading] = useState(false);

  // 🔥 Cuando "data" cambia, rellenamos los campos
  useEffect(() => {
    if (!data) return;

    const monthMap = {
      ene: "01",
      feb: "02",
      mar: "03",
      abr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      ago: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dic: "12",
    };

    let fechaFormateada = "";

    if (data.fecha) {
      const regex = /^(\d{2})-([a-z]{3})-(\d{4})/i;
      const match = data.fecha.match(regex);

      if (match) {
        const [_, day, monthStr, year] = match;
        const month = monthMap[monthStr.toLowerCase()] || "01";
        fechaFormateada = `${year}-${month}-${day}`;
      }
    }

    setFecha(fechaFormateada);
    setDescripcion(data.descripcion || "");
    setSelectedClientes(data.clienteIds || []);
    if (data.eessId) {
      const codigo = (data.eessCodigo ?? "").trim();
      const nombre = (data.eessNombre ?? "").trim();
      const label = (codigo ? `${codigo} - ` : "") + nombre;

      setSelectedEess({
        id: data.eessId,
        codigo,
        nombre,
        label,
      });
    } else {
      setSelectedEess(null);
    }

    setTarjeta(data.tarjeta || "");
  }, [data]);

  useEffect(() => {
    const loadClientes = async () => {
      setClientesLoading(true);
      try {
        const resp = await apiFetchJson(apiRoutes.clientes.combo, true);
        setClientes(resp ?? []);
      } finally {
        setClientesLoading(false);
      }
    };
    loadClientes();
  }, []);

  const isValid = true;

  const canSave = isValid && !saving;

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);

    try {
      const payload = {
        fecha,
        descripcion,
        clienteId: selectedClientes?.length > 0 ? selectedClientes[0] : null,
        eessId: selectedEess?.id || null,
        tarjetaId: tarjeta || null,
      };

      await appFetchJson(apiRoutes.informacion.update(data.id), {
        method: "PATCH", // <--- CORREGIDO
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      onUpdated();
      onClose();
    } catch (error) {
      console.error("Error al guardar:", error);
      alert("No se pudo guardar la información");
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalBase
      title="Editar Información"
      onClose={onClose}
      footer={
        <div className="btn-row">
          <BtnGuardar isValid={canSave} saving={saving} onClick={guardar} />
          <BtnCancelar onClick={onClose} />
        </div>
      }
    >
      {/* FECHA */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">Fecha</label>
        <input
          type="date"
          className="input w-full"
          value={fecha}
          //onChange={(e) => setFecha(e.target.value)}
          disabled
        />
      </div>

      {/* DESCRIPCIÓN */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">Información</label>
        <input
          type="text"
          className="input w-full"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          placeholder="Descripción…"
        />
      </div>

      {/* CLIENTE */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">Cliente</label>
        <ComboMultiSelectClientes
          items={clientes}
          loading={clientesLoading}
          selected={selectedClientes}
          onChange={setSelectedClientes}
        />
      </div>

      {/* EE.SS */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-3 max-w-3xl">
        <label className="label-strong text-right mt-2">EE.SS</label>
        <EessAutocomplete
          value={selectedEess}
          onChange={setSelectedEess}
          placeholder="Buscar EE.SS..."
        />
      </div>
    </ModalBase>
  );
}
